<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Drawer from "vue-simple-drawer";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablolarDetayParametreHedefTanim from "@/models/StrPerfTablolarDetayParametreHedefTanim";
import AddEdit from "./AddEdit.vue";
import IndexDetay from "./IndexDetay.vue";

export default {
  mixins: [Api, Sabit, StrPerfTablolarDetayParametreHedefTanim],
  page: {
    title: "Detay Parametre Hedef Tanımları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Drawer,
    PageHeader,
    AddEdit,
    IndexDetay
  },
  data() {
    return {
      title: this.$t("StrPerfTablolarDetayParametreHedefTanim.Title"),
      items: [
        {
          text: this.$t("StrPerfTablolarDetayParametreHedefTanim.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("StrPerfTablolarDetayParametreHedefTanim.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("StrPerfTablolarDetayParametreHedefTanim.Title"),
          active: true,
        },
      ],
      islem: "",
      TableData: [],
      AddEdit: "",
      FormTitle: "",
      FilitrelemePenceresi: false,
      Filter: {
        Hedefadi: "",
      },
      Guncelleme: 0,
      siralama:"&Asc=Hedefadi",
      DataUpdate: "",
      Tip:"",
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
    };
  },

  methods: {
    Get() {
      this.Guncelleme = this.Guncelleme+1;
       let Filter="&UstidDoluMu=false";
      
       if (this.Filter.Hedefadi != "" && this.Filter.Hedefadi != null) {
      
          Filter = Filter + "&Hedefadi=" + this.Filter.Hedefadi;
        }
        this.ActionsFilterGet({ Service: "StrPerfTablolarDetayParametreHedefTanim", Page: this.Page, Filter: Filter }).then((res) => {

        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },

    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />

      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input type="text" @input="Filter.Hedefadi.length >= 3 || Filter.Hedefadi.length == 0 ? Get() : ''" 
                    v-model="Filter.Hedefadi" class="form-control" placeholder="Arama..." />
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <button type="button" class="btn btn-secondary btn-rounded mb-2 me-2" @click="rightDrawer"><i class="mdi mdi-text-search me-1"></i> {{ this.$t("StrPerfTablolarDetayParametreHedefTanim.Page.Filtreleme") }}</button>

                  <button type="button" class="btn btn-primary btn-rounded mb-2 me-2" v-b-modal.StrPerfTablolarDetayParametreHedefTanim @click="(DataUpdate = StrPerfTablolarDetayParametreHedefTanimData), (AddEdit = 'Add'),(Tip='HedefAdd')"><i class="mdi mdi-plus me-1"></i> {{ this.$t("StrPerfTablolarDetayParametreHedefTanim.Page.YeniKayitEkle") }}</button>
                </div>
              </div>
            </div>

            <div class="table-responsive">

              <table class="table table-striped table-bordered mb-0">
                <thead>
                  <tr>
                    <th style="width: 85px;" scope="col-2"></th>

                    <th scope="col">Başlık
                    <i style="margin-left:10px"  class="bx bx-sort-z-a  fa-xl"></i>
                  </th>
                    <th style="width: 85px; text-align: center; vertical-align: middle;">{{ this.$t("StrPerfTablo.Table.Islem") }}</th>
                  </tr>
                </thead>
                <tbody v-for="Data in TableData" :key="Data.Id">
                  <tr>
                    <th scope="row" class="custom-accordion">
                      <a class="text-body fw-medium py-1 d-flex align-items-center" data-toggle="collapse" v-b-toggle="'CollapseAltTablo' + Data.Id" role="button" aria-expanded="false" aria-controls="categories-collapse">
                        <i class="mdi mdi-chevron-up accor-down-icon ms-auto"></i>
                      </a>
                    </th>
                    <td>{{ Data.Hedefadi }}</td>

                    <td style="width: 85px; text-align: center; vertical-align: middle;">
                 

                      <b-button-group>
      
                          <b-button variant="primary" v-b-modal.StrPerfTablolarDetayParametreHedefTanim @click="(DataUpdate = Data.Id), 
                          (AddEdit = 'Add'), (Tip = 'AltHedefAdd')">
                            <i class="fas fa-plus"></i></b-button>
                          <b-button variant="success" v-b-modal.StrPerfTablolarDetayParametreHedefTanim @click="(DataUpdate = Data), (AddEdit = 'Edit'),(Tip = 'HedefEdit')"><i class="far fa-edit"></i></b-button>
                          <b-button variant="danger" @click="Delete('StrPerfTablolarDetayParametreHedefTanim', Data.Id)"><i class="far fa-trash-alt"></i></b-button>
                      </b-button-group>



                    </td>
                  </tr>
                  <tr>
                    <td colspan="10">
                      <b-collapse class="collapse show" :id="'CollapseAltTablo' + Data.Id">

                        <IndexDetay :Guncelle="Guncelleme"
                        :Ustid="Data.Id" @Ustidvar = "(DataUpdate = $event),(AddEdit = 'Edit'),(Tip='AltHedefEdit')"
              
                     />
                      
                      </b-collapse>
                    </td>
                  </tr>
                </tbody>
              </table>

              <br />

              <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get"  :Tip = "Tip"/>

      <Drawer @close="rightDrawer" :align="'right'" :closeable="true" :maskClosable="true" :zIndex="1002">
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("StrPerfTablolarDetayParametreHedefTanim.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("StrPerfTablolarDetayParametreHedefTanim.Filtreleme.Content") }}
            <hr />
            <div class="mb-3 ">
              <label class="col-md-12 col-form-label">{{ $t("StrPerfTablolarDetayParametreHedefTanim.Filtreleme.Hedefadi") }}</label>
              <b-form-input v-model="Filter.Hedefadi" for="text" value=""></b-form-input>
            </div>

            <b-button @click="Get(),rightDrawer()" class="btn btn-primary" variant="primary">{{ $t("StrPerfTablolarDetayParametreHedefTanim.Filtreleme.Button") }}</b-button>
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
